var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.233 23.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Success symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.688 -63.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.437 86.93c-1.682-.23-6.121-1.45-6.878-1.891-.573-.334-1.222-1.297-2.326-3.45-1.717-3.35-2.182-4.854-2.45-7.916-.17-1.957-.145-2.122.341-2.277.299-.095.904-.913 1.405-1.9 1.053-2.074 3.005-3.939 4.576-4.37a38.609 38.609 0 0 0 2.554-.84c1.706-.631 5.069-.747 6.809-.235 1.55.457 5.266 3.317 6.179 4.757.41.648.884 1.84 1.053 2.65.423 2.043.208 6.027-.387 7.157-.614 1.163-2.508 3.21-2.972 3.21-.485 0-.48-.016.425-1.8 1.265-2.488 1.49-3.898.96-6.009-.897-3.57-2.95-6.352-5.585-7.566-2.03-.936-5.725-.45-7.912 1.042-.741.505-1.281 1.221-1.909 2.531-.481 1.005-1.107 2.077-1.39 2.383-1.213 1.31-1.324 4.21-.245 6.37.568 1.139 2.522 3.313 2.979 3.316.151 0 .628.185 1.06.41 1.086.567 2.606.289 3.06-.56.48-.897 1.376-1.422 2.75-1.61 1.68-.23 2.427.042 3.188 1.161 1.206 1.776.622 4.368-1.192 5.286-.625.316-2.4.382-4.093.15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.25d2da55b008b2ffdcaa7f94d17fc956.svg";
export { ForwardRef as ReactComponent };